import { render, staticRenderFns } from "./petlooking.vue?vue&type=template&id=16c1eca0&scoped=true&"
import script from "./petlooking.vue?vue&type=script&lang=js&"
export * from "./petlooking.vue?vue&type=script&lang=js&"
import style0 from "./petlooking.vue?vue&type=style&index=0&id=16c1eca0&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c1eca0",
  null
  
)

export default component.exports